import { render, staticRenderFns } from "./PartesHospedaje.vue?vue&type=template&id=765e7f20&"
import script from "./PartesHospedaje.vue?vue&type=script&lang=js&"
export * from "./PartesHospedaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports